<template>
  <div class="detail_container">
    <div class="top-img_container">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <Breadcrumb :title="currentTitle"></Breadcrumb>

    <div class="content_wrap">
      <!-- 左侧内容 -->
      <div class="left-content">
        <h1 class="title">{{ techDetail.title }}</h1>
        <p class="date">{{ techDetail.date }}</p>
        <hr class="tech-item-ling">
        <div class="content">
          <p v-for="( item, index ) in techDetail.content" :key="index" class="content-item">
            {{ item }}
          </p>
        </div>
        <div class="img-wrap">
          <img :src="techDetail.image" :alt="techDetail.title">
        </div>
      </div>

      <!-- 右侧内容 -->
      <div class="right-content">
        <div class="item-list">
          <div class="item" v-for="( item ) in relatedTechList" :key="item.id" @click="gotoPage(item.id)">
            <div class="tech-item">
              <div class="img-box">
                <img :src="item.image" :alt="item.title" class="tech-item-img" />
              </div>
              <div class="tech-item-info">
                <p class="tech-item-title">{{ item.title }}</p>
                <p class="tech-item-date">{{ item.date }}</p>
              </div>
            </div>
            <hr class="tech-item-ling">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DragCarousel from '@/components/drag-carousel/index.vue'
  import Breadcrumb from './components/Breadcrumb.vue'
  export default {
    components: { DragCarousel, Breadcrumb },
    data() {
      return {
        imgData: [
          {
            src: require('@/assets/img/coreTechnology/detailBG-1.jpeg'),
            alt: '核心技术'
          }
        ],
        id: this.$route.params.id,
        currentTitle: this.$route.meta.title,
        techDetail: null,
        dataSource: []
      }
    },
    created () {
      const dataSource = this.$route.meta.dataSource
      if (dataSource) {
        this.dataSource = dataSource
      }
      this.getTechDetail(dataSource)
    },
    watch: {
      '$route.params.id'(newId) {
        this.id = newId
        this.getTechDetail(this.dataSource)
      }
    },
    computed: {
      relatedTechList() {
        if (!this.dataSource) return []
        return this.dataSource.filter( item => item.id !== Number(this.id)).slice(0, 6)
      }
    },
    methods: {
      getTechDetail(dataSource) {
        if (!dataSource) {
          this.$message.error('数据源不存在')
          return this.$router.push('/coreTechnology/index')
        }

        this.techDetail = dataSource.find(item => item.id === Number(this.id))
        if (!this.techDetail) {
          this.$message.error('信息不存在')
          this.$router.push('/coreTechnology/index')
        }
      },
      gotoPage(id) {
        this.$router.push(`/coreTechnology/detail/${id}`)
      }
    }
  }
</script>

<style scoped lang="scss">
.detail_container {
  .top-img_container {
    margin-top: 80px;
    @media screen and (max-width: 768px) {
      margin: 0;
    }
  }

  .content_wrap {
    display: flex;
    width: 94%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 4% 0 8%;

    .left-content {
      flex: 0 0 70%;
      margin-right: 30px;
      padding: 0 30px 30px 30px;
      background-color: rgba(255, 255, 255, 1);
      @media screen and (max-width: 768px) {
        flex: 1;
        margin: 0;
      }

      .title {
        line-height: 64px;
        font-size: 32px;
        font-weight: 400;
        color: rgb(33, 37, 41);
        margin-bottom: 15px;
        @media screen and (max-width: 768px) {
          line-height: 50px;
          font-size: 24px;
        }
      }

      .date {
        min-height: 20px;
        font-size: 14px;
        color: rgba(153, 153, 153);
        font-weight: normal;
      }

      .content {
        font-size: 16px;
        line-height: 1.6;
        text-indent: 2em;
        margin-bottom: 28px;
        .content-item {
          line-height: 2;
        }
      }

      .img-wrap {
        margin-bottom: 20px;

        img {
          width: 100%;
          max-width: 100%;
          height: auto;
          display: block;
          margin: 0 auto;
        }
      }
    }

    .right-content {
      flex: 1;
      max-width: 100%;
      max-height: 100%;
      @media screen and (max-width: 768px) {
        display: none;
      }

      .item-list {
        display: flex;
        flex-direction: column;
        max-width: 1200px;
        margin: 0 auto;

        .item {
          @media screen and (max-width: 768px) {
            flex-grow: 0;
            flex-shrink: 0;
            flex-basis: calc(100% / 1);
          }

          &:hover {
            cursor: pointer;
          }

          .tech-item {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            width: 100%;
            padding-top: 10px;
            padding-bottom: 10px;

            .img-box {
              flex: 0 0 40%;
              padding-right: 30px;
              align-self: center;

              img {
                width: 100%;
                border-radius: 4px;
              }
            }

            .tech-item-info {
              flex: 1;
              align-self: center;
              max-width: 100%;
              max-height: 100%;

              .tech-item-title {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
                font-weight: normal;
                line-height: 1.5;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
              .tech-item-date {
                line-height: 1.5;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
              }
            }

          }
        }
      }
    }

    .tech-item-ling {
      width: 100%;
      height: 0;
      margin: 16px 0;
      border: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
